
	import { Component, Vue } from 'vue-property-decorator';
	import AuthModal from '@/components/AuthModal.vue';

	import Modal from '@/components/Modal.vue';
	import AgentErrorModal from '@/components/AgentErrorModal.vue';
	import FitstationSVG from '@/components/FitstationSVG.vue';
	import { Observer } from 'mobx-vue';
	import Loading from '@/components/Loading.vue';
	import StoreModal from '@/components/StoreModal.vue';
	import LeroyModal from '@/components/LeroyModal.vue';
	import NotesButton from '@/components/NotesButton.vue';
	import CloseSVG from '@/components/CloseSVG.vue';
	import SignOutModal from '@/components/modals/SignOutModal.vue';
	import DesignInspectionButton from '@/components/DesignInspectionButton.vue';
	import PDFButton from '@/components/PDFButton.vue';
	import NotesModal from '@/components/modals/NotesModal.vue';
	import PatientModal from '@/components/modals/PatientModal.vue';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import Snackbar from '@/components/Snackbar.vue';
	import TimeoutError from '@/components/TimeoutError.vue';
	import NoConnectionError from '@/components/NoConnectionError.vue';
	import ErrorHandler from '@/components/ErrorHandler.vue';
	import TokenExpiredMessage from '@/components/TokenExpiredMessage.vue';
	import MetadataSavingPopup from '@/components/MetadataSavingPopup.vue';
	import Updater from '@/components/Updater.vue';
	import SearchButton from '@/components/SearchButton.vue';
	import EditSVG from '@/components/EditSVG.vue';
	import { joinPath } from '@/utils';
	import Cookies from 'js-cookie';
	import { MobileAppRedirectData } from '@/store/authStore';
	import PrivacyPage from '@/views/privacy-page/PrivacyPage.vue';
	import DownloadUsbAgent from '@/views/download/DownloadUsbAgent.vue';

	@Observer
	@Component({
		components: {
			PrivacyPage,
			DownloadUsbAgent,
			EditSVG,
			StoreModal,
			Loading,
			FitstationSVG,
			AgentErrorModal,
			AuthModal,
			Modal,
			MetadataSavingPopup,
			LeroyModal,
			NotesButton,
			CloseSVG,
			SignOutModal,
			DesignInspectionButton,
			PDFButton,
			NotesModal,
			DualButtonModal,
			Snackbar,
			TimeoutError,
			NoConnectionError,
			ErrorHandler,
			TokenExpiredMessage,
			Updater,
			SearchButton,
			PatientModal
		}
	})
	export default class App extends Vue {
		private readonly PRESCRIPTION_CATEGORIES = {
			ShellModifications: 'Shell',
			PostingOptions: 'Posting',
			Coverings: 'Coverings',
			Accommodations: 'Accommodations'
		};

		addPatient() {
			this.$state._patient.clear();
			this.$router.push('getting-started');
		}

		setCategoryIdx(idx: string) {
			const hash = `#${idx.charAt(0).toUpperCase() + idx.slice(1)}`;
			if (location.hash !== hash) {
				// Avoid NavigationDuplicated: Avoided redundant navigation to current location:
				this.$router.push(hash);
			}
		}

		async signOut() {
			await this.$state.engine.auth.logout();
		}

		public agentPanel() {
			// Agent panel is at http://localhost:5000/panel or similar:
			const url = joinPath(window.appConfig.VUE_APP_USBAGENT_BASE_URI, 'panel');
			window.open(url, '_blank')?.focus();
		}

		public async created() {
			console.log('env', window.appConfig.VUE_APP_ENV);
			if (window.appConfig.VUE_APP_ENV !== 'production') {
				console.log('%c[Frontend version: %s]', 'color: green; font-weight: bold;', window.appConfig.VUE_APP_VERSION);
			}

			if (this.$route.name === 'Onboard') {
				return;
			}

			this.$state.auth.init();
			this.inactivityLogout();

			const routes = ['Landmark selection', 'Results', 'Prescription', 'Order Review'];

			addEventListener('focus', (e) => {
				this.$state.auth.refreshExpired();
			});
		}

		public inactivityLogout() {
			const time = 1620000; // 27 min

			const startTimer = () => {
				return setTimeout(() => {
					if (this.$state.auth.operator.loggedIn) this.$state.utils.inactivityLogout = true;
				}, time);
			};

			let timeOutId = startTimer();

			const resetTimer = () => {
				clearTimeout(timeOutId);
				timeOutId = startTimer();
			};

			const events = ['mousemove', 'click', 'wheel', 'keydown'];
			events.forEach((event) => window.addEventListener(event, resetTimer));
		}

		public logout() {
			this.$state.auth.logout();
		}

		public endSession() {
			this.$state.auth.endSession();
		}

		onAuthHide() {
			location.reload();
		}

		private async storeChosen(store: any) {
			if (typeof store === 'string') {
				store = this.$state.auth.employeeStores.find((s) => s.storeID === store);
				const currentCookie = JSON.parse(Cookies.get('mobile-app-redirect-data') || '{}');
				const storeID = localStorage.getItem('storeID');
				const mobileAppCookie: MobileAppRedirectData = {
					refreshToken: currentCookie.refreshToken,
					refreshTokenExpiresAt: currentCookie.refreshTokenExpiresAt,
					storeID: store.storeID
				};

				Cookies.set('mobile-app-redirect-data', JSON.stringify(mobileAppCookie));
				await this.$state.auth.init();
			}
			localStorage.setItem('storeID', store.storeID);
			this.$state.auth.storeSelectionModal = false;
			this.$state.auth.chosenStore = store;
		}

		get env() {
			return window.appConfig.VUE_APP_ENV;
		}

		get version() {
			if (this.env !== 'production') {
				return window.appConfig.VUE_APP_VERSION;
			} else {
				return 'Version information is not available in production';
			}
		}
	}
